import axiosIns from '@/libs/axios'

const controller = 'marital-statuses'

export default {
  async getAll() {
    return axiosIns.get(controller).then(res => res.data)
  },
}
